/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncLayerPayloadDto
 */
export interface SyncLayerPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    layerId?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncLayerPayloadDto
     */
    layerNumber: number;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    limitType: SyncLayerPayloadDtoLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    limit: string;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    excess?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    deductibles?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    premium: string;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    totalDeductions?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncLayerPayloadDto
     */
    lineSize?: string;
}


/**
 * @export
 */
export const SyncLayerPayloadDtoLimitTypeEnum = {
    Primary: 'Primary',
    ExcessOfLoss: 'Excess of Loss',
    QuotaShare: 'Quota Share'
} as const;
export type SyncLayerPayloadDtoLimitTypeEnum = typeof SyncLayerPayloadDtoLimitTypeEnum[keyof typeof SyncLayerPayloadDtoLimitTypeEnum];


/**
 * Check if a given object implements the SyncLayerPayloadDto interface.
 */
export function instanceOfSyncLayerPayloadDto(value: object): value is SyncLayerPayloadDto {
    if (!('layerNumber' in value) || value['layerNumber'] === undefined) return false;
    if (!('limitType' in value) || value['limitType'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('premium' in value) || value['premium'] === undefined) return false;
    return true;
}

export function SyncLayerPayloadDtoFromJSON(json: any): SyncLayerPayloadDto {
    return SyncLayerPayloadDtoFromJSONTyped(json, false);
}

export function SyncLayerPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncLayerPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'layerId': json['layerId'] == null ? undefined : json['layerId'],
        'layerNumber': json['layerNumber'],
        'limitType': json['limitType'],
        'limit': json['limit'],
        'excess': json['excess'] == null ? undefined : json['excess'],
        'deductibles': json['deductibles'] == null ? undefined : json['deductibles'],
        'premium': json['premium'],
        'totalDeductions': json['totalDeductions'] == null ? undefined : json['totalDeductions'],
        'lineSize': json['lineSize'] == null ? undefined : json['lineSize'],
    };
}

export function SyncLayerPayloadDtoToJSON(json: any): SyncLayerPayloadDto {
    return SyncLayerPayloadDtoToJSONTyped(json, false);
}

export function SyncLayerPayloadDtoToJSONTyped(value?: SyncLayerPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layerId': value['layerId'],
        'layerNumber': value['layerNumber'],
        'limitType': value['limitType'],
        'limit': value['limit'],
        'excess': value['excess'],
        'deductibles': value['deductibles'],
        'premium': value['premium'],
        'totalDeductions': value['totalDeductions'],
        'lineSize': value['lineSize'],
    };
}

